<template>
    <div v-show="hits">
        <v-data-table
                :headers="headers"
                :items="hits"
                :items-per-page="-1"
                sort-by="name"
                hide-default-footer
                item-key="objectID"
                class="secondary elevation-1 mt-2 forced-bar-grey"
                style="margin-top: 0px !important; border-radius: 0;"
        >
            <template v-slot:item="{ item }">
              <tr :data-id="item.id">
                <td @click="edit(item)"
                  :key="item.uuid+column.attribute"
                  v-for="(column, columnNumber) in headers"
                  style="cursor: pointer">
                  <v-row v-if="columnNumber === 0">
                    <div style="width: 10px" class="d-flex align-center mx-3">
                      <v-icon style="height: 100%;">description</v-icon>
                    </div>
                    <v-col cols="10" class="pr-0">
                      <span>{{ item[column.attribute] }}</span>
                    </v-col>
                  </v-row>
                  <span v-else>{{ item[column.attribute] }}</span>
                </td>
              </tr>
            </template>
        </v-data-table>
        <div class="" v-observe-visibility="visibilityChanged"></div>
        <!-- <div v-if="refresh" class="d-block" style="min-height:5px;" v-observe-visibility="{ callback: (isVisible, entry) => visibilityChanged(isVisible, entry), intersection: { root: null, threshold: 0.1 } }"></div> -->
    </div>
</template>
<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  hits: Array,
  edit: Function,
  customHeaders: Array,
  hideCommonHeaders: Boolean,
  showMore: Function,
  loading: Boolean
});

const refresh = ref(false);
const genericHeaders = ref([
  { text: 'Title', align: 'left', value: 'wtitle' },
  { text: 'Content Type', value: 'wtype' },
]);
const commonHeaders = ref([
  { text: 'Last modified by', value: 'lastUpdateUserName', order: 1000 },
  { text: 'Last modified', value: 'lastUpdateTime', isDate: true, order: 1005 },
  { text: 'Status', value: 'status', order: 1010, sortable: false }
]);
const selectedItem = ref(null);

const headers = computed(() => {
  let headers = (props.customHeaders.length ? props.customHeaders : genericHeaders.value);

  if(!props.hideCommonHeaders) {
    headers = headers.concat(props.commonHeaders)
  }

  return headers;
});

const visibilityChanged = (isVisible) => {
  if (isVisible && !props.loading) {
    props.showMore();
  }
}

</script>